import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-3">关于桃花视频的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqData.map((item, i) => (
            <details key={i} className="group rounded-xl bg-background-50 border border-background-200/50 overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between p-5 list-none">
                <h3 className="text-sm font-semibold text-foreground-100 pr-4">{item.q}</h3>
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-background-200/60 flex items-center justify-center group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-foreground-400 text-sm"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-400 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}